import { UserIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';
import { GHOST, INSET_PANEL } from '@components/ui/designTokens';

/**
 * Paso previo a crear un cliente nuevo — igual que la pantalla "¿qué tipo de
 * cliente desea registrar?" del legado (`EditAndCreateCustomerForm.cshtml`,
 * `IsForCuestion`). Solo aplica al ALTA; en edición el tipo ya está definido
 * por `customer.customerKind` y no se vuelve a preguntar.
 */
interface CustomerTypeChooserProps {
  onSelect: (kind: 'PARTICULAR' | 'BUSINESS') => void;
  onCancel: () => void;
}

export function CustomerTypeChooser({ onSelect, onCancel }: CustomerTypeChooserProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col px-7 py-6">
      <p className="mb-5 text-[14px] text-secondary-500 dark:text-secondary-400">
        ¿Qué tipo de cliente deseas registrar?
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <button
          type="button"
          onClick={() => onSelect('PARTICULAR')}
          data-testid="customer-type-chooser-particular-button"
          className={`${INSET_PANEL} flex flex-col items-center gap-3 px-6 py-8 text-center transition-colors hover:bg-white dark:hover:bg-secondary-800`}
        >
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal-500/10 text-[#0d9488]">
            <UserIcon className="h-6 w-6" />
          </span>
          <span className="text-[15px] font-bold text-ink-850 dark:text-white">Particular</span>
          <span className="text-[13px] text-secondary-500 dark:text-secondary-400">
            Persona natural — cédula o pasaporte
          </span>
        </button>

        <button
          type="button"
          onClick={() => onSelect('BUSINESS')}
          data-testid="customer-type-chooser-business-button"
          className={`${INSET_PANEL} flex flex-col items-center gap-3 px-6 py-8 text-center transition-colors hover:bg-white dark:hover:bg-secondary-800`}
        >
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-teal-500/10 text-[#0d9488]">
            <BuildingOfficeIcon className="h-6 w-6" />
          </span>
          <span className="text-[15px] font-bold text-ink-850 dark:text-white">Comercial</span>
          <span className="text-[13px] text-secondary-500 dark:text-secondary-400">
            Persona jurídica — RUC y razón social
          </span>
        </button>
      </div>

      <div className="mt-6 flex justify-end">
        <button type="button" onClick={onCancel} className={GHOST} data-testid="customer-type-chooser-cancel-button">
          Cancelar
        </button>
      </div>
    </div>
  );
}
